import { createFileAtom } from 'lib/atoms/file-atom';
import { createMutationAtom } from 'atoms/create-resource-atom';
import { useMemo } from 'react';
import { createResourceAtom } from 'lib/atoms';
import { PreviewData } from './add-structure-grid';

// Create file upload atom for structure grid files
export const structureGridFileAtom = createFileAtom();

// Create mutation atom for structure grid file creation
export const createStructureGridFileAtom = createMutationAtom<
  null,
  'structureGridFile'
>();

export const usePreviewAtom = (href?: string) => {
  return useMemo(() => createResourceAtom<PreviewData>(href), [href]);
};
